import react, { useEffect, useRef, useState } from "react";
import "../styles/PatientReportFileTemplateCreate.scss";

import { useSelector, useDispatch } from "react-redux";
import { getReportDetails, postReportDetails, putReportDetails } from "../Redux/Thunk/Actions";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function ReportView(props) {
  const [valueChange, setValueChange] = useState({});
  const [reportDetailsPost,setReportDetailsPost]=useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const reportViewDate = useSelector((state) => state.counter.reportViewDate);
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
  const day = currentDate.getDate().toString().padStart(2, "0");

  let monthName = new Date(month).toLocaleDateString("default", {
    month: "long",
  });

  const formattedDate = `${day}/${month}/${year}`;

  useEffect(() => {
    (async () => {
      props.loaderchange("true")
      const response = await dispatch(
        getReportDetails(reportViewDate.selectedDate)
      );
      console.log(response.payload.data.data.length == 0, "mmmmm");
      response.payload.data.data.length ? setReportDetailsPost(true) : setReportDetailsPost(false);
      if (response.payload.status === 200) {
      props.loaderchange("false")
        const data = response.payload.data.data[0];
        setValueChange({
          date:reportViewDate.selectedDate,
          ...valueChange,
          ...data,
          
        });
      }
      else{
      props.loaderchange("false")
        props.popupalert("true")
        props.popuptext("Network Went Wrong, Please Try After Sometime")
      }
    })();
  }, []);
  const handleChange = (e) => {
    console.log({ [e.target.name]: e.target.value });
    console.log(valueChange);

    setValueChange({
      ...valueChange,
      [e.target.name]: e.target.value,
    });
  };

  const saveDetails = async () => {
    props.loaderchange("true")
    let filteredValue = { ...valueChange };
    delete filteredValue.date;
    let putData = {
      id: valueChange.id,
      value: filteredValue,
    };
    let postData = {
      ...valueChange
    }
    let response =  reportDetailsPost? await dispatch(putReportDetails(putData)):await dispatch(postReportDetails(postData));
    console.log(response.payload.status,'redkmk');
    if (response.payload.status==200) {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Report has been saved",
        showConfirmButton: false,
        timer: 1500
      }
    ) 
    navigate("/reportDetails")
      props.loaderchange("false")
    }
    else{
      props.loaderchange("false")
      props.popupalert("true")
      props.popuptext("Network went wrong ,Please try after sometime")
    }
    

  };

  const PrintDiv = () => {
    // console.log(valueChange,"response");
    // return
    var new_str = document.getElementById("ReportDetails").innerHTML;

    var originalContents = document.body.innerHTML;
    document.body.innerHTML = new_str;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    return false;
  };
  const renderTableTH = (value, options = {}) => {
    const { style = {}, colspan = 1 } = options;
    return (
      <th colspan={colspan} style={{ border: "1px solid black", ...style }}>
        {value}
      </th>
    );
  };
  const renderReportfield = (name, value, options = {}) => {
    const { styleSec = {}, styleLabel = {}, styleSpan = {} } = options;

    return (
      <>
        <section
          style={{ ...styleSec, margin: "0 10px 10px 10px", display: "flex" }}
        >
          <label
            style={{
              ...styleLabel,
              fontWeight: "600",
              marginRight: "5px",
              width: "max-content",
            }}
          >
            {name}
          </label>
          <span style={styleSpan}>{value}</span>
        </section>
      </>
    );
  };
  const renderInput = (name, type = "text", options = {}) => {
    const { style = {} } = options;
    return (
      <>
        <input
          defaultValue={valueChange[name]}
          type={type}
          name={name}
          onChange={handleChange}
          style={style}
        />
      </>
    );
  };

  return (
    <>
      <div
        className={
          sideactive ? "maincontainer-patient-sa" : "maincontainer-patient"
        }
      >
        <div className="row">
          <div className="col">
            <h3 className="page-title">Report View</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="/" style={{ textDecoration: "none", color: "black" }}>
                  Dashboard
                </a>

                {/* <a
                  href="/patientreports"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  &nbsp;Patient Reports
                </a> */}
              </li>
              <li className="breadcrumb-item active">
                <a
                  href="/reportDetails"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  Report
                </a>
              </li>
              <li className="breadcrumb-item active">Report View</li>
            </ul>
          </div>
        </div>
        {/* <h1>Report Details</h1> */}
        <div
          style={{ backgroundColor: "white", maxWidth: "100%" }}
          className="patientreport"
          id="reportcreate"
        >
          <div>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr style={{ backgroundColor: "#fceb4e" }}>
                  {renderTableTH(
                    `ASCAS DAILY REPORTS - ${reportViewDate.monthName.toUpperCase()} MONTH - ${
                      reportViewDate.formattedDate
                    }`,
                    { colspan: 2, style: { fontWeight: "600" } }
                  )}
                </tr>
                {[
                  "Daily New Patients||new_patient_daily",
                  "Daily Review||daily_review",
                  "Daily Scan||daily_scan",
                  "Only Scan( Outside Patients )||only_scan",
                  "Daily Blood Sample Collection||daily_blood_sample_collection",
                  "Daily IUI||daily_iui",
                  "Daily IVF Injection||daily_ivf_injection",
                  "Daily Semen Collection||daily_semen_collection",
                  "Daily DFI||daily_dfi",
                  "Morning Foot Falls||morning_foot_falls",
                  "Evening Foot Falls||evening_foot_falls",
                  "Daily CTG||daily_ctg",
                  "No Fees Injection||no_fees_injection",
                  "No Fees Consultation||no_fees_consultation",
                  "Daily PAP Smear||daily_pap_smear",
                  "Daily Sperm Report||daily_sperm_report",
                  "Monthly New Patients||new_patient_monthly",
                  "Monthly Review Patients||monthly_review_patients",
                  "Monthly Scan||monthly_scan",
                  "Monthly Sperm Report||monthly_sperm_report",
                  "Monthly CTG||monthly_ctg",
                  "Monthly Blood Sample Collection||monthly_blood_sample_collection",
                  "Monthly Food Falls||monthly_food_falls",
                  "Monthly IUI||monthly_iui",
                  "Monthly IVF injection||monthly_ivf_injection",
                  "Monthly PAP Smear||monthly_pap_smear",
                  "Monthly DFI||monthly_dfi",
                  "PRP||prp",
                  "SSG||ssg",
                ].map((ele, ind) => {
                  return (
                    // className={ele.includes("Monthly")?"monthBGColor":""}
                    <tr
                      key={ind}
                      style={{
                        backgroundColor: `${
                          ele.includes("Monthly") ||
                          ele.includes("PRP") ||
                          ele.includes("SSG")
                            ? "#fac591"
                            : "transparent"
                        }`,
                      }}
                    >
                      {renderTableTH(ele.split("||")[0])}
                      {renderTableTH(
                        renderInput(ele.split("||")[1], "text", {
                          style: { height: "50px" },
                        })
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="reportFooter">
          <button className="Button_Create" onClick={saveDetails}>
            Save Details
          </button>
          <button className="Button_Create" onClick={PrintDiv}>
            Print Report
          </button>
        </div>
      </div>
      <div id="ReportDetails" style={{ display: "none" }}>
        <div className="demo" style={{ maxWidth: "1200px" }}>
          <div>
            <table style={{ width: "100%" }}>
              <tbody>
                <tr style={{ backgroundColor: "#fceb4e" }}>
                  {renderTableTH(
                    "ASCAS DAILY REPORTS - SEPTEMBER MONTH -10/09/2024",
                    { colspan: 2 }
                  )}
                </tr>
                {[
                  "Daily New Patients||new_patient_daily",
                  "Daily Review||daily_review",
                  "Daily Scan||daily_scan",
                  "Only Scan( Outside Patients )||only_scan",
                  "Daily Blood Sample Collection||daily_blood_sample_collection",
                  "Daily IUI||daily_iui",
                  "Daily IVF Injection||daily_ivf_injection",
                  "Daily Semen Collection||daily_semen_collection",
                  "Daily DFI||daily_dfi",
                  "Morning Foot Falls||morning_foot_falls",
                  "Evening Foot Falls||evening_foot_falls",
                  "Daily CTG||daily_ctg",
                  "No Fees Injection||no_fees_injection",
                  "No Fees Consultation||no_fees_consultation",
                  "Daily PAP Smear||daily_pap_smear",
                  "Daily Sperm Report||daily_sperm_report",
                  "Monthly New Patients||new_patient_monthly",
                  "Monthly Review Patients||monthly_review_patients",
                  "Monthly Scan||monthly_scan",
                  "Monthly Sperm Report||monthly_sperm_report",
                  "Monthly CTG||monthly_ctg",
                  "Monthly Blood Sample Collection||monthly_blood_sample_collection",
                  "Monthly Food Falls||monthly_food_falls",
                  "Monthly IUI||monthly_iui",
                  "Monthly IVF injection||monthly_ivf_injection",
                  "Monthly PAP Smear||monthly_pap_smear",
                  "Monthly DFI||monthly_dfi",
                  "PRP||prp",
                  "SSG||ssg",
                ].map((ele, ind) => {
                  return (
                    <tr
                      key={ind}
                      style={{
                        backgroundColor: `${
                          ele.includes("Monthly") ? "#fac591" : "transparent"
                        }`,
                      }}
                    >
                      {renderTableTH(ele.split("||")[0])}
                      {renderTableTH(valueChange[ele.split("||")[1]])}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
